import { render } from "./ChooseTab.vue?vue&type=template&id=b8e349ba&scoped=true"
import script from "./ChooseTab.vue?vue&type=script&lang=js"
export * from "./ChooseTab.vue?vue&type=script&lang=js"

import "./ChooseTab.vue?vue&type=style&index=0&id=b8e349ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b8e349ba"

export default script